import React, { useRef, useState } from "react";
import {
  SideBar as StyledSideBar,
  ContainerSideBar,
  StyledFaBars,
  StyledFaTimes,
  Overlay,
  ItemList,
} from "./styles";

import logoImg from "../../assets/senai_sidebar.png";
import { FaHome, FaUser, FaLaptopCode, FaBuilding, FaBriefcase } from "react-icons/fa";
import { useHistory } from "react-router-dom";

function SideBarAdmin({ links }) {
  const history = useHistory();
  const sideBarRef = useRef();
  const overlayRef = useRef();
  const [closed, setClosed] = useState(true);
  const [animar, setAnimar] = useState(undefined);

  const handlerToggleMenu = () => {
    setAnimar("true");
    if (closed) {
      overlayRef.current.style.opacity = 1;
      overlayRef.current.style.display = "flex";
      sideBarRef.current.style.width = "300px";
    } else {
      overlayRef.current.style.opacity = 0;
      overlayRef.current.style.display = "none";
      sideBarRef.current.style.width = "0px";
    }
    setClosed(!closed);
  };

  const navigateTo = (path) => {
    handlerToggleMenu();
    history.push(path);
  };

  return (
    <>
      <Overlay ref={overlayRef} onClick={handlerToggleMenu} />
      <ContainerSideBar>
        <StyledSideBar ref={sideBarRef}>
          <header>
            <img src={logoImg} alt="Logo Senai" />
            <h1>JOB</h1>
          </header>
          <ul>
            <ItemList
              onClick={() => navigateTo("/admin/home")}
              active={history.location.pathname === "/admin/home"}
            >
              <FaHome /> Home
            </ItemList>
            <ItemList
              onClick={() => navigateTo("/admin/vagas")}
              active={history.location.pathname === "/admin/vagas"}
            >
              <FaBriefcase /> Vagas
            </ItemList>
            <ItemList
              onClick={() => navigateTo("/admin/empresas")}
              active={history.location.pathname === "/admin/empresas"}
            >
              <FaBuilding /> Empresas
            </ItemList>
            <ItemList
              onClick={() => navigateTo("/admin/integracao-sg7")}
              active={history.location.pathname === "/admin/integracao-sg7"}
            >
              <FaLaptopCode /> Integração SG7
            </ItemList>
          </ul>
        </StyledSideBar>
        <span onClick={handlerToggleMenu}>
          {closed ? (
            <StyledFaBars animar={animar} size={25} />
          ) : (
            <StyledFaTimes size={25} />
          )}
        </span>
      </ContainerSideBar>
    </>
  );
}

export default SideBarAdmin;
